<template>
    <div class="exp_right">
        <b-row >
            <b-col >
                <div class="search-div mb-4">
                    <div class="search"></div>
                    <label htmlFor="inpt_search">
                        <input id="inpt_search" type="text"  placeholder="Search Experience"/>
                    </label>
                </div>
            </b-col>
        </b-row>
        <b-row class="photos mb-4" >
            <b-col cols="4" v-for="(photo,i) in photos" :key="i" class="photo">
                <figure><b-img fluid :src="photo.photo"></b-img></figure>
            </b-col>
        </b-row>
        <b-row class="extra-info">
            <b-col>
                <div class="extra_1"><h5>You might want to know about my decision to work as a ... </h5></div>
                <div v-for="(info, i) in extraInfo" :key="i" class="extra_2">
                    <div class="extra_3">
                        <figure>
                            <b-img fluid :src="info.image" style="height: 50px"></b-img>
                        </figure>
                        <p>{{ info.info }}</p>
                    </div>
                    <div style="flex-shrink: 0;"> <b-button class="ask" href="#contact">Ask Me</b-button></div>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    data () {
        return {
            extraInfo: [
                {
                    image: require('../assets/experience/coding_ask.png'),
                    info: 'full-stack developer',
                },
                {
                    image: require('../assets/experience/teaching_ask.jpg'),
                    info: 'Teacher',
                },
                {
                    image: require('../assets/experience/banking_ask.png'),
                    info: 'Bank loan officer',
                },
            ],
            photos: [
                { photo: require('../assets/experience/photo1.jpg') },
                { photo: require('../assets/experience/photo2.jpg') },
                { photo: require('../assets/experience/photo3.jpg') },
                { photo: require('../assets/experience/photo4.jpg') },
                { photo: require('../assets/experience/photo5.jpg') },
                { photo: require('../assets/experience/photo6.jpg') },
            ],
        }
    },
}
</script>
